var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { BrandButton as ZinniaBrandButton } from '@zapier/design-system';
import { useTracking } from '../../tracking';
export function BrandButton(_a) {
    var { text, openInNewTab } = _a, rest = __rest(_a, ["text", "openInNewTab"]);
    const { emitUserInteractionEvent } = useTracking();
    return (_jsx(ZinniaBrandButton, Object.assign({}, rest, { target: openInNewTab ? '_blank' : '_self', onClick: () => {
            emitUserInteractionEvent({
                event_action: 'click',
                interaction_name: 'call_to_action',
                interaction_raw_text: text,
                destination_href: rest.href,
                option_selected: 'cta_button',
            });
        } }, { children: text })));
}
//# sourceMappingURL=BrandButton.js.map